import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthApiBase } from "../utils/getApiBase";


export default function RegisterScreen() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    username: "",
    password: "",
    terms_accepted: false,
    gdpr_accepted: false,
  });

  const [loading, setLoading] = useState(false);
  const API = getAuthApiBase();

  const handleChange = (e) =>
    setForm({
      ...form,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API}/accounts/register/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (!res.ok) throw new Error("Registration failed");

      // Store tokens
      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);

      // → Proceed to activation screen
      navigate("/activate", { replace: true });
    } catch (err) {
      alert("Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cream-color px-6">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 border border-light-gray">
        <h1 className="text-2xl font-primary text-charcoal text-center mb-6">
          Create Your Account
        </h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 text-charcoal text-sm font-forms">
              Email
            </label>
            <input
              name="email"
              type="email"
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-light-gray rounded-md bg-very-light-gray focus:ring-rich-gold focus:border-rich-gold font-forms"
            />
          </div>

          <div>
            <label className="block mb-1 text-charcoal text-sm font-forms">
              Username
            </label>
            <input
              name="username"
              type="text"
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-light-gray rounded-md bg-very-light-gray focus:ring-rich-gold focus:border-rich-gold font-forms"
            />
          </div>

          <div>
            <label className="block mb-1 text-charcoal text-sm font-forms">
              Password
            </label>
            <input
              name="password"
              type="password"
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-light-gray rounded-md bg-very-light-gray focus:ring-rich-gold focus:border-rich-gold font-forms"
            />
          </div>

          <div className="flex items-center space-x-2">
            <input
              name="terms_accepted"
              type="checkbox"
              checked={form.terms_accepted}
              onChange={handleChange}
            />
            <label className="text-sm text-charcoal font-forms">
              I accept the Terms of Service
            </label>
          </div>

          <div className="flex items-center space-x-2">
            <input
              name="gdpr_accepted"
              type="checkbox"
              checked={form.gdpr_accepted}
              onChange={handleChange}
            />
            <label className="text-sm text-charcoal font-forms">
              I agree to data processing (GDPR)
            </label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-dominant-purple text-white py-3 rounded-md font-action text-sm hover:bg-dark-purple transition"
          >
            {loading ? "Creating Account…" : "Create Account"}
          </button>
        </form>

        <p className="mt-4 text-center text-sm text-charcoal">
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            className="text-rich-gold font-semibold underline cursor-pointer"
          >
            Sign in
          </span>
        </p>
      </div>
    </div>
  );
}